<div class="cw-layout">
  <app-workbench-header></app-workbench-header>

  <main class="cw-layout__main" aria-labelledby="job-list-title">
    <header class="cw-page-head">
      <div>
        <nav class="cw-breadcrumb" [attr.aria-label]="'open_jobs_list_reactive_jobs' | translate">
          <a routerLink="/openjobs">{{ "open_jobs_summary_title" | translate }}</a>
          <span aria-hidden="true">/</span>
          <span aria-current="page">{{ siteName || ("open_jobs_summary_unknown_site" | translate) }} - {{ jobTypeKey | translate }} {{ "open_jobs_list_jobs" | translate }}</span>
        </nav>
        <h1 class="cw-page-head__title" id="job-list-title">
          {{ siteName || ("open_jobs_summary_unknown_site" | translate) }} - {{ jobTypeKey | translate }} {{ "open_jobs_list_jobs" | translate }}
        </h1>
      </div>
      <div class="cw-thinksafe">
        <img class="cw-thinksafe__logo" src="/assets/thinksafe-logo.png" alt="ThinkSafe" />
        <span class="cw-thinksafe__link">Browse Health &amp; Safety Documents</span>
      </div>
    </header>

  <section class="cw-filters" [class.cw-filters--single]="subSites.length === 0" [attr.aria-label]="'open_jobs_list_filters' | translate">
    @if (subSites.length > 0) {
      <div class="cw-filters__item cw-card">
        <label class="cw-field__label" for="subsite-filter">{{ "open_jobs_list_filter_subsite" | translate }}</label>
        <select class="cw-field__control" id="subsite-filter" [(ngModel)]="selectedSubSite">
          <option value="">{{ "open_jobs_summary_show_all" | translate }}</option>
          @for (subSite of subSites; track subSite) {
            <option [value]="subSite">{{ subSite }}</option>
          }
        </select>
      </div>
    }

    <div class="cw-filters__item cw-card">
      <label class="cw-field__label" for="allocation-filter">{{ "open_jobs_list_filter_allocation" | translate }}</label>
      <select class="cw-field__control" id="allocation-filter" [(ngModel)]="allocationType">
        <option value="">{{ "open_jobs_summary_show_all" | translate }}</option>
        <option value="allocated">{{ "open_jobs_list_allocated" | translate }}</option>
        <option value="unallocated">{{ "open_jobs_list_unallocated" | translate }}</option>
      </select>
    </div>
  </section>

  @if (hasLoadError) {
    <div class="cw-state cw-state--error cw-card" role="alert">{{ "open_jobs_list_load_error" | translate }}</div>
  } @else if (!hasLoaded) {
    <div role="status" [attr.aria-label]="'signin_lbl_loading_jobs' | translate">
      <app-skeleton layout="table" [rows]="5" [columns]="subSites.length > 0 ? 9 : 8"></app-skeleton>
    </div>
  } @else if (hasLoaded && filteredJobs.length === 0) {
    <div class="cw-state cw-card" role="status">{{ "open_jobs_summary_empty" | translate }}</div>
  } @else if (hasLoaded && isPpm) {
    <section class="ppm-list" [attr.aria-label]="'open_jobs_list_ppm_jobs' | translate">
      @for (job of filteredJobs; track job.id) {
        <article class="ppm-card cw-card">
          <div class="ppm-card__primary">
            <h2>{{ "open_jobs_list_ppm_number" | translate: { number: job.referenceNumber } }}</h2>
            <span class="cw-chip">{{ job.jobStatusName | translate }}</span>
          </div>
          <dl>
            <div><dt>{{ "open_jobs_list_due_date" | translate }}</dt><dd>{{ job.eta ? (job.eta | date: 'dd/MM/yyyy') : ("open_jobs_summary_not_available" | translate) }}</dd></div>
            @if (job.subSite) { <div><dt>{{ "open_jobs_list_subsite" | translate }}</dt><dd>{{ job.subSite }}</dd></div> }
            <div><dt>{{ "open_jobs_list_fault_service" | translate }}</dt><dd>{{ job.faultServiceName || ("open_jobs_summary_not_available" | translate) }}</dd></div>
            <div>
              <dt>{{ "open_jobs_list_allocated_to" | translate }}</dt>
              <dd>
                @if (job.allocatedUserEmail) {
                  <div class="cw-allocation">
                    <span class="cw-allocation__company"><strong>{{ "open_jobs_list_company_name" | translate }}:</strong> {{ job.allocatedCompanyName || ("open_jobs_summary_not_available" | translate) }}</span>
                    <div class="cw-allocation__contact">
                      <span><strong>{{ "open_jobs_list_contact" | translate }}:</strong> @if (job.allocatedTechnicianName) { {{ job.allocatedTechnicianName }}, }{{ job.allocatedUserEmail }}@if (job.allocatedContactNumber) {, {{ job.allocatedContactNumber }}}</span>
                    </div>
                  </div>
                } @else {
                  <span class="cw-chip cw-chip--warning">{{ "open_jobs_list_unassigned" | translate }}</span>
                }
              </dd>
            </div>
          </dl>
          @if (job.notes) { <p class="ppm-card__notes">{{ job.notes }}</p> }
          <button class="cw-button cw-button--primary" type="button" (click)="openJob(job)">{{ "open_jobs_list_open_ppm" | translate }}</button>
        </article>
      }
    </section>
  } @else if (hasLoaded) {
    @if (hasPicturesError) {
      <div class="cw-pictures-error" role="alert">
        <span>{{ "open_jobs_list_pictures_error" | translate }}</span>
        <button class="cw-button cw-button--secondary" type="button" (click)="loadPictures()">{{ "open_jobs_list_pictures_retry" | translate }}</button>
      </div>
    }
    @let showPictures = hasVisiblePictures;
    <section class="cw-table-card cw-card" [attr.aria-label]="'open_jobs_list_reactive_jobs' | translate">
      <div class="cw-table-card__scroll">
      <table class="cw-table cw-jobs-table" role="table">
        <thead role="rowgroup">
          <tr role="row">
            <th class="cw-table__head-cell cw-jobs-table__id" scope="col" role="columnheader">{{ "open_jobs_list_job_id" | translate }}</th>
            @if (subSites.length > 0) { <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "open_jobs_list_subsite" | translate }}</th> }
            <th class="cw-table__head-cell cw-jobs-table__date" scope="col" role="columnheader">{{ "open_jobs_list_callout_date" | translate }}</th>
            <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "open_jobs_list_fault_service" | translate }}</th>
            <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "open_jobs_list_notes" | translate }}</th>
            <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "open_jobs_list_allocated_to" | translate }}</th>
            <th class="cw-table__head-cell cw-jobs-table__date" scope="col" role="columnheader">{{ "open_jobs_list_allocated_on" | translate }}</th>
            <th class="cw-table__head-cell cw-jobs-table__actions" scope="col" role="columnheader">{{ "open_jobs_list_action" | translate }}</th>
            @if (showPictures) {
              <th class="cw-table__head-cell cw-jobs-table__pictures" scope="col" role="columnheader">{{ "open_jobs_list_pictures" | translate }}</th>
            }
            @if (showWorkOrderDownload) {
              <th class="cw-table__head-cell cw-jobs-table__work-order" scope="col" role="columnheader">{{ "open_jobs_list_work_order" | translate }}</th>
            }
          </tr>
        </thead>
        <tbody role="rowgroup">
          @for (job of filteredJobs; track job.id; let alternate = $odd) {
            <tr class="cw-table__row" [class.cw-job-row--alternate]="alternate" role="row">
              <td class="cw-table__cell cw-table__cell--lead" [attr.data-label]="'open_jobs_list_job_id' | translate" role="cell">
                <a class="job-id-link"
                   [routerLink]="['/openjobs', siteId, jobType, job.id]"
                   [queryParams]="{ siteName: siteName }">{{ job.referenceNumber }}</a>
              </td>
              @if (subSites.length > 0) {
                <td class="cw-table__cell cw-table__cell--wrap" [attr.data-label]="'open_jobs_list_subsite' | translate" role="cell"><span>{{ job.subSite || ("open_jobs_summary_not_available" | translate) }}</span></td>
              }
              <td class="cw-table__cell" [attr.data-label]="'open_jobs_list_callout_date' | translate" role="cell">
                @if (job.eta) {
                  <time [attr.datetime]="job.eta | date: 'yyyy-MM-ddTHH:mm:ss'">{{ job.eta | date: 'dd/MM/yyyy' }}<br />{{ job.eta | date: 'hh:mm a' }}</time>
                } @else {
                  <span>{{ "open_jobs_summary_not_available" | translate }}</span>
                }
              </td>
              <td class="cw-table__cell cw-table__cell--wrap" [attr.data-label]="'open_jobs_list_fault_service' | translate" role="cell"><span>{{ job.faultServiceName }}</span></td>
              <td class="cw-table__cell cw-table__cell--wrap" [attr.data-label]="'open_jobs_list_notes' | translate" role="cell"><span>{{ job.notes }}</span></td>
              <td class="cw-table__cell cw-table__cell--wrap" [attr.data-label]="'open_jobs_list_allocated_to' | translate" role="cell">
                @if (job.allocatedUserEmail) {
                  <div class="cw-allocation">
                    <span class="cw-allocation__company"><strong>{{ "open_jobs_list_company_name" | translate }}:</strong> {{ job.allocatedCompanyName || ("open_jobs_summary_not_available" | translate) }}</span>
                    <div class="cw-allocation__contact">
                      <span><strong>{{ "open_jobs_list_contact" | translate }}:</strong> @if (job.allocatedTechnicianName) { {{ job.allocatedTechnicianName }}, }{{ job.allocatedUserEmail }}@if (job.allocatedContactNumber) {, {{ job.allocatedContactNumber }}}</span>
                    </div>
                    <span class="cw-chip cw-allocation__status">{{ job.jobStatusName | translate }}</span>
                  </div>
                } @else {
                  <span class="cw-unassigned">{{ "open_jobs_list_unassigned" | translate }}</span>
                }
              </td>
              <td class="cw-table__cell" [attr.data-label]="'open_jobs_list_allocated_on' | translate" role="cell"></td>
              <td class="cw-table__cell cw-table__cell--actions" [attr.data-label]="'open_jobs_list_action' | translate" role="cell">
                <div class="cw-table__actions">
                  <button class="cw-button cw-button--secondary" type="button" (click)="openAllocateTo(job)">{{ "open_jobs_list_allocate_to" | translate }}</button>
                  @if (canResendJobDetails(job)) {
                    <button class="cw-button cw-button--secondary" type="button" (click)="resendJobDetails()">{{ "open_jobs_list_resend_job_details" | translate }}</button>
                  }
                </div>
              </td>
              @if (showPictures) {
              <td class="cw-table__cell" [attr.data-label]="photosByJob[job.id]?.length ? ('open_jobs_list_pictures' | translate) : null" role="cell">
                @if (photosByJob[job.id]?.length) {
                  <button class="cw-button cw-pictures-toggle" type="button"
                    [attr.aria-expanded]="expandedPhotoJobs.has(job.id)"
                    [attr.aria-controls]="'job-pictures-' + job.id"
                    (click)="togglePictures(job.id)">
                    <mat-icon aria-hidden="true">{{ expandedPhotoJobs.has(job.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
                    {{ (expandedPhotoJobs.has(job.id) ? "open_jobs_list_pictures_hide" : "open_jobs_list_pictures_show") | translate: { count: photosByJob[job.id].length } }}
                  </button>
                }
              </td>
              }
              @if (showWorkOrderDownload) {
                <td class="cw-table__cell" [attr.data-label]="'open_jobs_list_work_order' | translate" role="cell">
                  <button class="cw-button cw-button--secondary cw-download-button" type="button" (click)="downloadWorkOrder(job)">
                    <mat-icon aria-hidden="true">download</mat-icon>
                    {{ "open_jobs_list_download" | translate }}
                  </button>
                </td>
              }
            </tr>
            @if (photosByJob[job.id]?.length) {
              <tr class="cw-pictures-row" [class.cw-job-row--alternate]="alternate" role="row" [hidden]="!expandedPhotoJobs.has(job.id)" [id]="'job-pictures-' + job.id">
                <td class="cw-pictures-cell" role="cell" [attr.colspan]="7 + (subSites.length > 0 ? 1 : 0) + (showPictures ? 1 : 0) + (showWorkOrderDownload ? 1 : 0)">
                  <div class="cw-pictures" [attr.aria-label]="('open_jobs_list_pictures' | translate) + ': ' + job.referenceNumber">
                    @for (photo of photosByJob[job.id]; track photo.id) {
                      <figure class="cw-picture">
                        @if (photo.thumbnail) {
                          <img [src]="'data:image/jpeg;base64,' + photo.thumbnail" [alt]="photo.caption || photo.fileName" width="88" height="88" loading="lazy">
                        } @else {
                          <div class="cw-picture__placeholder"><mat-icon aria-hidden="true">image_not_supported</mat-icon><span class="visually-hidden">{{ "open_jobs_list_picture_unavailable" | translate }}</span></div>
                        }
                        <figcaption>{{ photo.caption || photo.fileName }}</figcaption>
                      </figure>
                    }
                  </div>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
      </div>
    </section>
  }

  @if (selectedJob) {
    <div class="allocation-backdrop">
      <section class="allocation-dialog" role="dialog" aria-modal="true" aria-labelledby="allocation-dialog-title">
        <header class="allocation-dialog__header">
          <h2 id="allocation-dialog-title">{{ "open_jobs_list_allocate_to" | translate }}</h2>
          <button mat-icon-button type="button" [disabled]="isAllocating" (click)="closeAllocateTo()" [attr.aria-label]="'open_jobs_list_close' | translate">
            <mat-icon>close</mat-icon>
          </button>
        </header>

        <form (ngSubmit)="confirmAllocation()">
          <div class="allocation-dialog__body">
            <mat-radio-group name="allocationMode" [(ngModel)]="allocationMode" [disabled]="isAllocating" (change)="changeAllocationMode()" [attr.aria-label]="'open_jobs_list_allocation_type' | translate">
              <mat-radio-button [value]="AllocationMode.INTERNAL">{{ "open_jobs_list_internal" | translate }}</mat-radio-button>
              <mat-radio-button [value]="AllocationMode.EXTERNAL">{{ "open_jobs_list_external" | translate }}</mat-radio-button>
            </mat-radio-group>

            <mat-form-field appearance="outline">
              <mat-label>{{ "open_jobs_list_email" | translate }}</mat-label>
              <input matInput type="email" name="allocationEmail" [(ngModel)]="allocation.email" (ngModelChange)="changeAllocationEmail()" maxlength="100" required email [disabled]="isAllocating" placeholder="email@email.com">
            </mat-form-field>

            @if (isExternalAllocation) {
              <mat-form-field appearance="outline">
                <mat-label>{{ "open_jobs_list_company_name" | translate }}</mat-label>
                <input matInput type="text" name="allocationCompany" [(ngModel)]="allocation.companyName" minlength="5" maxlength="200" required [disabled]="isAllocating" [matAutocomplete]="companyAutocomplete" [placeholder]="'open_jobs_list_company_name' | translate">
                <mat-autocomplete #companyAutocomplete="matAutocomplete">
                  @for (company of filteredSubconCompanies; track company.id) {
                    <mat-option [value]="company.name">{{ company.name }}</mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>

              @if (hasNoSubconCompanies && !allocation.companyName.trim()) {
                <p class="allocation-dialog__error" role="alert">{{ "open_jobs_list_no_companies" | translate }}</p>
              }
            }

            <div>
              <strong id="allocation-send-work-order-label">{{ "open_jobs_list_send_work_order" | translate }}</strong>
              <mat-radio-group name="sendWorkOrder" [(ngModel)]="allocation.sendWorkOrder"
                [disabled]="isAllocating" aria-labelledby="allocation-send-work-order-label"
                aria-describedby="allocation-send-work-order-hint">
                <mat-radio-button [value]="true">{{ "open_jobs_list_yes" | translate }}</mat-radio-button>
                <mat-radio-button [value]="false">{{ "open_jobs_list_no" | translate }}</mat-radio-button>
              </mat-radio-group>
            </div>

            @if (allocationErrorKey) {
              <p class="allocation-dialog__error" role="alert">{{ allocationErrorKey | translate }}</p>
            }
          </div>

          <footer class="allocation-dialog__footer">
            <button mat-stroked-button type="button" [disabled]="isAllocating" (click)="closeAllocateTo()">{{ "open_jobs_list_cancel" | translate }}</button>
            <button mat-raised-button type="submit" [disabled]="!canConfirmAllocation || isAllocating">{{ "open_jobs_list_confirm_allocation" | translate }}</button>
          </footer>
        </form>
      </section>
    </div>
  }
  </main>
  <app-workbench-footer></app-workbench-footer>
</div>